import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-redirect-card',
  templateUrl: './redirect-card.component.html',
  styleUrls: ['./redirect-card.component.scss'],
})
export class RedirectCardComponent implements OnInit {
  @Input() data: any;

  constructor(private router: Router) {}

  ngOnInit() {}

  redirectTo() {
    if (!this.data.link) return;
    this.router.navigate([this.data.link]);
  }
}
